module.exports = __webpack_public_path__ + "img/3.bdbbf590.png";